export enum ModulesID {
  CONTRACT = "112cae0c-d0d5-4cbf-8534-0b0a49ef4a87",
  CERTIFICATE = "7768a66f-b079-4f60-802e-5b7b24a7ae22",
  CONCRETING = "88fae1a5-41ec-412a-8efe-e6473f0bbc53",
  INVOICE = "9a3ecf20-cec5-4f58-bc5e-467d372cf89f",
  CONCRETING_REQUEST = "b0b0b0b0-b079-4f60-802e-5b7b24a7ae22",
  CLIENT = "c0c0c0c0-b079-4f60-802e-5b7b24a7ae22",
  AMOUNTS = "d0d0d0d0-b079-4f60-802e-5b7b24a7ae22"
}
